<template>
  <div class="post-preview-body">
    <p class="post-preview-body__content"
       v-html="trimHref"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'postPreviewBody',
  data() {
    return {
      trimTextLength: 300,
      regex: /\[(.*?)\]/g,
      social: {
        vk: {
          domen: 'https://vk.com/',
        },
        fb: {
          domen: 'https://www.facebook.com/',
        },
        tw: {
          domen: 'https://twitter.com/',
        },
      },
    };
  },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    replaceByNetwork() {
      const matches = this.post.text.match(this.regex);
      if(this.social[this.post.network_name]) {
        if (matches) {
          const matchedValues = matches.map(match => match.replace('[', this.social[this.post.network_name].domen).replace(']', '')).join(' ');
          const matchedArray = matchedValues.split('|');
          const link = `<a href="${matchedArray[0]}" target="_blank">${matchedArray[1]}</a>`;
          this.post.text = this.post.text.replace(matches[0], link);
        }
      }
    },
  },
  computed: {
    trimHref() {
      this.replaceByNetwork();
      return this.trimmedText;
    },
    trimmedText() {
      if (this.trimTextLength > this.post.text) {
        return this.post.text;
      }
      return `${this.post.text.substring(0, this.trimTextLength)} ...`;
    },
  },
};
</script>

<style lang="stylus">
.post-preview
  &-body
    width 100%
    overflow hidden
    margin-bottom 25px
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;

    color: #000000;

&__show-more
      cursor pointer
      font-weight bold
      color #460303
      margin 1em 0
</style>
